import React from "react";
import { Container, Typography, Toolbar, AppBar } from "@mui/material";
import Atras from "./atras";

const Perfil = () => {
  const styles = {
    cont: {
      position: "absolute",
      left: "50%",
      transform: "translateX(-50%)",
      textAlign: "center",
      margin: 0,
      padding: 0,
      boxSizing: "border-box",
    },
    user: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "110px",
    },
  };
  return (
    <Container>
      <AppBar position="fixed">
        <Toolbar
          sx={{
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <Atras color="inherit" />

          <Container style={styles.user}>
            <Typography variant="h5" gutterBottom>
              Términos de servicios
            </Typography>
          </Container>
        </Toolbar>
      </AppBar>

      <Container
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          width: "100%",
          textAlign: "left",
          marginTop: 120,
        }}
      >
        <Typography variant="subtitle1" component="div" gutterBottom>
          <h2>
            <strong>Términos y Condiciones</strong>
          </h2>

          <p>Última actualización: 1 de septiembre de 2026</p>

          <p>
            Bienvenido a Skach. Estos Términos y Condiciones ("Términos")
            regulan el uso de la aplicación Skach (la "Plataforma"), operada
            por Dapur Tecnología ("nosotros", "nuestro"). Al crear una cuenta
            o utilizar la Plataforma, aceptás estos Términos. Si no estás de
            acuerdo, no debés utilizar Skach.
          </p>

          <h3>
            <strong>1. ¿Qué es Skach?</strong>
          </h3>

          <p>
            Skach es un marketplace que conecta a Clientes que necesitan que
            se realice un trabajo con Freelancers que ofrecen sus servicios.
            Los Clientes publican proyectos y los Freelancers envían
            propuestas para realizarlos. Skach no es parte del acuerdo de
            trabajo entre Cliente y Freelancer: actuamos como intermediarios
            que facilitan el contacto, la comunicación y, cuando corresponde,
            el pago.
          </p>

          <h3>
            <strong>2. Tu cuenta</strong>
          </h3>

          <p>
            Para usar Skach necesitás crear una cuenta como Cliente o
            Freelancer, indicando datos reales (email, nombre, teléfono,
            localidad). Sos responsable de mantener la confidencialidad de tu
            contraseña y de toda actividad que ocurra en tu cuenta. Debés ser
            mayor de 18 años para registrarte.
          </p>

          <h3>
            <strong>3. Publicación de proyectos y propuestas</strong>
          </h3>

          <p>
            Los Clientes son responsables de la veracidad y legalidad de los
            proyectos que publican. Los Freelancers son responsables de la
            veracidad de su perfil, sus habilidades y sus propuestas. Skach
            puede remover cualquier proyecto o propuesta que infrinja estos
            Términos o la ley aplicable.
          </p>

          <h3>
            <strong>4. Comunicación dentro de la Plataforma</strong>
          </h3>

          <p>
            Para proteger a la comunidad, no está permitido compartir datos de
            contacto (teléfonos, emails, usuarios de redes sociales o de
            aplicaciones de mensajería) dentro del chat de Skach con el fin
            de coordinar trabajo por fuera de la Plataforma. El incumplimiento
            de esta regla puede derivar en la suspensión y, en caso de
            reincidencia, en la eliminación definitiva de la cuenta.
          </p>

          <h3>
            <strong>5. Pagos y suscripciones</strong>
          </h3>

          <p>
            Skach ofrece planes de suscripción pagos para Freelancers, que
            otorgan beneficios como mayor cantidad de propuestas mensuales,
            insignias de perfil y mejor posicionamiento en las búsquedas. Los
            pagos se procesan a través de proveedores externos (PayPal y
            Mercado Pago); Skach no almacena los datos completos de tu
            tarjeta o medio de pago. Las suscripciones se renuevan
            automáticamente salvo que las canceles antes del próximo período
            de facturación.
          </p>

          <h3>
            <strong>6. Conducta prohibida</strong>
          </h3>

          <p>No está permitido:</p>
          <ul>
            <li>Publicar contenido falso, difamatorio, discriminatorio o ilegal;</li>
            <li>Intentar eludir el pago a través de la Plataforma;</li>
            <li>Crear cuentas falsas o suplantar la identidad de terceros;</li>
            <li>Usar la Plataforma para actividades fraudulentas.</li>
          </ul>

          <h3>
            <strong>7. Suspensión y eliminación de cuentas</strong>
          </h3>

          <p>
            Podemos suspender o eliminar tu cuenta si incumplís estos
            Términos. También podés eliminar tu cuenta en cualquier momento
            desde la sección "Eliminar cuenta" de tu perfil; esta acción es
            permanente e implica la pérdida de tus proyectos, propuestas y
            conversaciones.
          </p>

          <h3>
            <strong>8. Propiedad intelectual</strong>
          </h3>

          <p>
            El nombre, el logo y el diseño de Skach son propiedad de Dapur
            Tecnología. No está permitido reproducir, copiar o redistribuir
            el contenido de la Plataforma sin autorización.
          </p>

          <h3>
            <strong>9. Limitación de responsabilidad</strong>
          </h3>

          <p>
            Skach facilita el contacto entre Clientes y Freelancers, pero no
            garantiza la calidad, seguridad ni legalidad de los proyectos
            publicados, ni el cumplimiento de los acuerdos entre las partes.
            En la máxima medida permitida por la ley, Dapur Tecnología no
            será responsable por daños indirectos derivados del uso de la
            Plataforma.
          </p>

          <h3>
            <strong>10. Modificaciones</strong>
          </h3>

          <p>
            Podemos actualizar estos Términos en cualquier momento. Te vamos
            a notificar los cambios importantes publicando la nueva versión
            en esta página.
          </p>

          <h3>
            <strong>11. Ley aplicable</strong>
          </h3>

          <p>Estos Términos se rigen por las leyes de la República Argentina.</p>

          <h3>
            <strong>12. Contacto</strong>
          </h3>

          <p>
            Si tenés preguntas sobre estos Términos, escribinos a{" "}
            <a href="mailto:support@notiline.com">support@notiline.com</a>.
          </p>
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 4, mb: 2 }}>
          © 2026 Skach - Dapur Tecnología. Todos los derechos reservados.
        </Typography>
      </Container>
    </Container>
  );
};

export default Perfil;
